import React from 'react'
import Swal from 'sweetalert2';

const escapeHtml = (value) => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

function ErrorAlert(message, title, icon, timer, details) {

  let dataTimer =  3000

  if(timer !== undefined){
    dataTimer = timer
  }
  if (title === undefined || message === undefined || icon === undefined) {
    message = "Ocurrio un error."
    title = "Error!"
    icon = 'error'
  }

  const detailText = details?.detail || "";
  const rawText = details?.raw ? JSON.stringify(details.raw) : "";
  const footerText = [detailText, rawText].filter(Boolean).join(" | ");

  return (
    //We show a error alert 
    Swal.fire({
      icon: icon,
      title: title, //mensaje en pantalla
      text: message,
      footer: footerText
        ? `<small style="word-break: break-word; text-align: left;">${escapeHtml(footerText)}</small>`
        : undefined,
      showConfirmButton: true,
      timer: dataTimer
    })
  )
}



export default ErrorAlert
